import { render, staticRenderFns } from "./TotalKilometres.vue?vue&type=template&id=22d28301&"
import script from "./TotalKilometres.vue?vue&type=script&lang=js&"
export * from "./TotalKilometres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports